var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5C11 12.7761 10.7761 13 10.5 13H3.5C3.22386 13 3 12.7761 3 12.5V3.5C3 3.22386 3.22386 3 3.5 3H10.5C10.7761 3 11 3.22386 11 3.5V12.5ZM11 20.5C11 20.7761 10.7761 21 10.5 21H3.5C3.22386 21 3 20.7761 3 20.5V15.5C3 15.2239 3.22386 15 3.5 15H10.5C10.7761 15 11 15.2239 11 15.5V20.5ZM13 20.5C13 20.7761 13.2239 21 13.5 21H20.5C20.7761 21 21 20.7761 21 20.5V11.5C21 11.2239 20.7761 11 20.5 11H13.5C13.2239 11 13 11.2239 13 11.5V20.5ZM13.5 9C13.2239 9 13 8.77614 13 8.5V3.5C13 3.22386 13.2239 3 13.5 3H20.5C20.7761 3 21 3.22386 21 3.5V8.5C21 8.77614 20.7761 9 20.5 9H13.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.f69bed09fc7bc39ae8386fa723c34282.svg";
export { ForwardRef as ReactComponent };